import { CommonModule } from "@angular/common";
import { Component, ViewEncapsulation } from "@angular/core";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { param } from "jquery";
import { SharedModule } from "../../../../shared.module";
import { FormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import { DropdownConfig } from "../../../design-system/dropdown/dropdown.modal";

@Component({
    selector: 'ng-select-renderer',
    templateUrl: './ng-select-renderer.component.html',
    styleUrls: ["./ng-select-renderer.component.scss"],
    standalone: true,
    imports: [CommonModule, TranslateModule, SharedModule, FormsModule, NgSelectModule]
})

export class NgSelectRendererComponent implements ICellRendererAngularComp {

    showCheckIcon: boolean;
    placeholder = "";
    items = [];
    value: any;
    params: any;
    dropdownConfig: DropdownConfig = {
        id: 'country',
        label: 'Country',
        placeholder: 'Select a country',
        value: null,
        size: 'sm',
    };

    constructor() { }

    initilize(params: ICellRendererParams) {
        if (params.colDef.headerComponentParams) {
            this.items = params.colDef.headerComponentParams.dropdownItems;
            this.placeholder = params.colDef.headerComponentParams.placeholder;
            this.dropdownConfig = {
                ...this.dropdownConfig,
                placeholder: this.placeholder,
            }
        }
        this.value = params.getValue();
        this.dropdownConfig = {
            ...this.dropdownConfig,
            value: this.value
        }
    }

    agInit(params: any): void {
        this.params = params;
        this.initilize(params);
    }

    refresh(params: any): boolean {
        this.initilize(params);
        return true;
    }

    onChange($event) {
        if (this.params.onChange instanceof Function) {
            const params = {
                event: $event,
                rowData: this.params.node.data
            }
            this.params.onChange(params);
        }
    }
}
